import React from "react";

function Footer() {
  return (
    <div
      style={{
        backgroundImage: "linear-gradient(315deg, #a71d31 0%, #3f0d12 74%)",
        width: "100%",
        height: "12vh",
        marginTop: "3%",
        textAlign: "center",
      }}
    >
      <br />
      <h3 style={{ color: "white", fontWeight: "bold" }}>Shoe Fanatic</h3>
      <span style={{ color: "white" }}>© 2023 Shoe Fanatic</span>
    </div>
  );
}

export default Footer;
